import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { ModalDirective } from "ngx-bootstrap/modal";
import * as $ from 'jquery';

@Component({
  selector: 'app-assign-assesments-modal',
  templateUrl: './assign-assesments-modal.component.html',
  styleUrls: ['./assign-assesments-modal.component.scss']
})
export class AssignAssesmentsModalComponent implements OnInit {

    @ViewChild('assignAssessment', {static: true}) public modal: ModalDirective;
    @ViewChild('modalContent', {static: true}) modalContent: ElementRef;
    date1: Date = new Date();
    date2: Date = new Date();
    date3: Date = new Date();
    users: string[] =
    [
        "Mary Johnson",
        "Joe Doe",
        "Warrent Thompson",
    ];

    tags: string[] =
    [
        "Business",
        "ELI",
        "New Client"
    ];


    settings = {
        bigBanner: true,
        timePicker: true,
        format: 'dd-MMM-yyyy hh:mm',
        defaultOpen: false
    };

    _next: boolean = false;


  constructor() { }

  ngOnInit() {

  }

  show(): void {
      this._next = false;
      this.modal.show();
      $('.wc-date-container').css({ "border":"1px solid #ccc","font-size": "14px"});
      $('.wc-date-container span').css("color", "#000");
  }

  onShown(): void {
      console.log("onShow");
  }

  close(): void {
      this.modal.hide();
  }
  removeTr(event: any) {
      console.log(event);
      event.target.parentNode.parentNode.remove();
  }

  next() {
      this._next = true;
  }

  //removeTag(event: any) {
  //    console.log(event);
  //    event.target.parentNode.remove();
  //}

  removeTag(index, event: any) {
      //console.log(event);
      //event.target.parentNode.remove();

      this.tags.splice(index, 1);
      console.log(this.tags);
  }

  addTag(tag: string) {
      let split_tags = tag.split(',');
      for (var i = 0; i < split_tags.length; i++) {
          //tag = tag.replace(" ", "_");
          var exist = this.tags.indexOf(split_tags[i]);
          if (exist != -1) {
              //alert("This Tag is already exist");
              //return;
          } else {
              this.tags.push(split_tags[i]);
              console.log(this.tags);
              $('#newTag').val('');
          }
      }
    }


  preventSpace(value: string, event: any) {
      if (value == null || value == "") {
          if (event.keyCode == 32) {
              return false;
          }
      }
      if (value == " ") {
          $('#newTag').val('');
      }
  }



}
